import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { apiBase } from './services/api-config';
import { AuthService } from './services/auth.service';
import { AuthActions } from './state/auth/auth.actions';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
  styles: []
})
export class AppComponent implements OnInit {
  private http = inject(HttpClient);
  private store = inject(Store);
  private authSvc = inject(AuthService);

  ngOnInit(): void {
    // Cloudflare Access redirect dance (see error.interceptor.ts) — probe the API as soon as the
    // app boots, before the user ever touches the login form, so an unauthenticated browser gets
    // bounced through Access's OTP challenge immediately instead of only discovering the block
    // when the login POST itself fails. /api/health needs no app-level auth, so a successful
    // response here only proves Access let the request through, nothing about app login state.
    this.http.get(`${apiBase}/health`).subscribe({ error: () => {} });

    // The NgRx auth store only gets `user` populated as a side effect of the login form's
    // dispatch (loginSuccess) — it does not survive a page refresh/direct navigation, since the
    // JWT in localStorage is the only thing that does. Rehydrate it from /api/auth/me whenever a
    // (not-yet-expired) token already exists, so anything reading the current user/personnelId
    // from the store (e.g. Part B/Phase 8's cylinder custody clearing) works after a refresh, not
    // only in the same session the login form was submitted.
    if (this.authSvc.isAuthenticated()) {
      this.store.dispatch(AuthActions.loadMe());
    }
  }
}
